<template>
  <div class="musiclibrary mp3-playlists container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <b-card no-body id="musicLibraryMp3Card " class="p-3 mx-1">
            <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
              <dataset
                :datasetI18n="datasetI18n"
                v-slot="{ ds }"
                :ds-data="playlists_list"
                :ds-filter-fields="{
                  title: startsWithFilter,
                }"
                :ds-search-in="['title']"
                :ds-search-as="{ searchTest }"
              >
                <div class="row mb-2" :data-page-count="ds.dsPagecount">
                  <div class="col-xl-7 col-md-6">
                    <b-input-group
                      class="input-group-search input-group-search-doomyoga"
                    >
                      <template #prepend>
                        <font-awesome-icon
                          icon="fa-solid fa-magnifying-glass"
                          size="lg"
                        />
                      </template>
                      <dataset-search
                        ds-search-placeholder="Search"
                        class="form-control-doomyoga"
                    /></b-input-group>
                  </div>

                  <div
                    class="col-xl-3 col-md-6 px-md-0 px-3 addButtonContainerDiv"
                  >
                    <b-button
                      variant="doomyoga-primary"
                      id=""
                      class="btn btn-filter m-0 btn-lg-doomyoga"
                      @click="clickAddCategory"
                    >
                      + Add New
                    </b-button>
                    <!-- <AddMp3Playlist /> -->
                    <SaveCategory
                      category="music_library"
                      type="mp3"
                      client_name="DY"
                      :title="save_category_modal_title"
                      :action_type="save_category_action_type"
                      :category_id="selected_category_id"
                      :category_title="selected_category_title"
                      :category_description="selected_category_description"
                    />
                  </div>
                </div>
                <dataset-show class="d-none" :ds-show-entries="12" />

                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h3
                          class="
                            media-category-title media-category-title-doom-yoga
                          "
                        >
                          {{ title }}
                        </h3>
                      </div>
                    </div>
                    <dataset-item class="row mb-3">
                      <template #default="{ row }">
                        <div
                          class="
                            col-xl-2 col-lg-3 col-md-3 col-6
                            mb-4
                            px-md-3 px-2
                          "
                        >
                          <router-link
                            :to="
                              '/doom_yoga/music_library/mp3_playlist/' + row.id
                            "
                            class="card-link eventLink"
                          >
                            <MediaCard
                              class="media-card-item"
                              :title="row.title"
                              :duration="row.time_duration"
                              :img_src="row.cover_image"
                              media_type="music"
                              music_type="mp3"
                            />
                            
                         
                          </router-link> <b-row class="my-2"
                            ><b-col>
                              <b-button-group
                                class="
                                  d-block
                                  text-center
                                  btn-group-actions-doomyoga
                                "
                              >
                                <b-button
                                  variant="doomyoga-primary"
                                  size="sm"
                                  @click="
                                    clickEditCategory(
                                      row.id,
                                      row.title,
                                      row.description
                                    )
                                  "
                                  >Edit</b-button
                                >
                                <b-button
                                  variant="doomyoga-info"
                                  size="sm"
                                  @click="clickDeleteCategory(row.id)"
                                  >Delete</b-button
                                ></b-button-group
                              ></b-col
                            ></b-row
                          >
                        </div>
                      </template>
                      <template #noDataFound>
                        <div class="col-md-12 pt-2">
                          <p class="text-center datasetNoFoundP noDataFoundDY">
                            No data found
                          </p>
                        </div>
                      </template>
                    </dataset-item>
                  </div>
                </div>
                <div
                  class="
                    d-flex
                    flex-md-row flex-column
                    justify-content-between
                    align-items-center
                  "
                >
                  <dataset-info
                    class="mb-2 mb-md-0 datasetInfo datasetInfoDY"
                  />
                  <dataset-pager class="datasetPagerDY" />
                </div>
              </dataset>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
    <!-- delete modal -->
    <DeleteCategory
      :client_name="client_name"
      :category_id="selected_category_id"
      :media_type="media_library"
      sub_media_type="mp3"
    />
    <!-- end delete modal-->
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaCard from "../media/MediaCard.vue";
import AddMediaCard from "../media/AddMediaCard.vue";
import AddMp3Playlist from "../media/AddMp3Playlist.vue";
import SaveCategory from "../media/SaveCategory.vue";
import DeleteCategory from "../media/DeleteCategory.vue";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";

export default {
  name: "MP3Playlists",
  components: { MediaCard, AddMediaCard, AddMp3Playlist , SaveCategory, DeleteCategory},
  data() {
    return {
      media_library:"music_library",
      client_name: "DY",

      title: "My Music ",
      playlists_list: [
        // {
        //   id: 1,
        //   title: "Playlist 1",
        //   time_duration: "14 min 30 sec",
        //   cover_image: null,
        // },
        // {
        //   id: 2,
        //   title: "Playlist 2",
        //   time_duration: "8 min 30 sec",
        //   cover_image: null,
        // },
        // {
        //   id: 3,
        //   title: "Playlist 3",
        //   time_duration: "10 min 30 sec",
        //   cover_image: null,
        // },
        // {
        //   id: 4,
        //   title: "Playlist 4",
        //   time_duration: "30 min 30 sec",
        //   cover_image: null,
        // },
        // {
        //   id: 5,
        //   title: "Playlist 5",
        //   time_duration: "45 min 30 sec",
        //   cover_image: null,
        // },
      ],
      selected_category: null,

      onlineFilter: "",
      selected: 12,
      startsWith: "",
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "<",
        next: ">",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },
      save_category_modal_title: "Add New Playlist",
      selected_category_id: null,
      selected_category_title: null,
      selected_category_description: null,
      save_category_action_type: "add",
    };
  },
  mounted() {    this.getMediaCategoryList();
},
  computed: {},
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(playlists_list).slice(5, 5);
    //   this.playlists_list = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,
    getMediaCategoryList() {
      console.log("in get categories");
      // this.category_list = [];
      let formData = new FormData();
      formData.append("media_library", this.media_library);
      axios
        .post("media/library/categories", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.playlists_list = response.data;
          // this.category_list_select = response.data.slice(0);

          // this.category_list_select.push({ title: "New category", id: "new" })
        });
    },
    clickAddCategory() {
      console.log("in click add category");
      this.save_category_modal_title = "Add New Playlist";
      this.save_category_action_type = "add";
      this.selected_category_id = null;
      this.selected_category_title = null;
      this.selected_category_description = null;
      this.$root.$emit("bv::show::modal", "saveCategoryModal");
    },
    clickEditCategory(id, title, description) {
      console.log("in click edit category");
      console.log(id, title, description);
      this.save_category_modal_title = "Playlist Info";
      this.save_category_action_type = "edit";
      this.selected_category_id = id;
      this.selected_category_title = title;
      if (description == null || description == "null") {
        this.selected_category_description = null;
      } else {
        this.selected_category_description = description;
      }
      this.$root.$emit("bv::show::modal", "saveCategoryModal");
      // $('#saveCategoryModal').modal('show')
    },
    clickDeleteCategory(id) {
      console.log("click delete category", id);
      this.selected_category_id = id;

      this.$root.$emit("bv::show::modal", "deleteCategoryModal");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/music_library/MP3Playlists.vue